import { CSSProperties } from 'react';

// Inline style that paints `iconBackground` BEHIND an icon image: it's set as
// the element's own CSS background, so the skin PNG (transparent around the
// item) renders on top of it and the background can never cover the skin.
// Returns {} when there's no background, so it's safe to spread into any style.
export function iconBackgroundStyle(iconBackground?: string | null): CSSProperties {
    if (!iconBackground) return {};
    return {
        backgroundImage: `url("${iconBackground}")`,
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
    };
}
